@import "stylesheets/sdx/button/button";
@import "../../globals/scss/header.scss";

.component {
  .heading {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: $baseline-2;

    .initials {
      height: $baseline-5 * 2; // 80px
      width: $baseline-5 * 2; // 80px
      @include typo-display-3;
      @include font-semi-light;
    }

    .salutation {
      padding-bottom: $baseline;
      text-align: center;
    }
  }
}
